import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useResearchCenterEdit } from '@/module/ResearchCenter/model/ResearchCenterQuery';
import {
  ResearchCenterSchema,
  defaultResearchCenterValues,
  researchCenterSchema,
} from '@/module/ResearchCenter/model/ResearchCenterSchema';

import { useAppNotification } from '@feature/utils';

import { ResearchCenterForm } from './ResearchCenterForm';
import { ResearchCenter } from './model/ResearchCenterTypes';

interface ResearchCenterEditProps {
  researchCenter: ResearchCenter;
}

const convert = (researchCenter: ResearchCenter): ResearchCenterSchema => ({
  ...researchCenter,
});

export function ResearchCenterEdit(props: ResearchCenterEditProps) {
  const { researchCenter } = props;
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = useResearchCenterEdit(researchCenter.id);

  const notification = useAppNotification();
  const onSubmit = (values: ResearchCenterSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: notification.success,
    });
  };

  const values = useMemo(() => convert(researchCenter), [researchCenter]);
  const navigate = useNavigate();

  return (
    <ResearchCenterForm
      title={t('researchCenters.form.title.edit')}
      schema={researchCenterSchema}
      defaultValues={defaultResearchCenterValues}
      isError={isError}
      isSuccess={isSuccess}
      values={values}
      onSubmit={onSubmit}
      isSubmitting={isPending}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
